export function detectMimeType(b64) {
    let signatures = {
        JVBERi0: "application/pdf",
        R0lGODdh: "image/gif",
        R0lGODlh: "image/gif",
        iVBORw0KGgo: "image/png",
        "/9j/": "image/jpg",
    };
    for (var s in signatures) {
        if (b64.indexOf(s) === 0) {
            return signatures[s];
        }
    }
}
export function getImageString(b64) {
    if (b64)
        return "data:" + detectMimeType(b64) + ";base64," + b64;
    else
        return "";
}
export function base64toPDF(respData) {
    var decodedPdfContents = window.atob(respData);
    var byteArrays = new Uint8Array(decodedPdfContents.length);
    for (var i = 0; i < decodedPdfContents.length; i++) {
        byteArrays[i] = decodedPdfContents.charCodeAt(i);
    }
    var blobs = new Blob([byteArrays.buffer], { type: "application/pdf" });
    var _pdfurls = URL.createObjectURL(blobs);
    var links = document.createElement("a");
    document.body.appendChild(links);
    links.href = _pdfurls;
    var evts = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false,
    });
    links.dispatchEvent(evts);
    window.URL.revokeObjectURL(_pdfurls);
    links.remove();
}
